
import ToggleableInputGroup from "./ToggleableInputGroup";
import '../../style/Personalize.css';
export default function Personalize({personalSettings, setPersonalSettings}) {

  return (
    <div>
      <ToggleableInputGroup
        label="Add a Title"
        placeholder="Enter title..."
        checked={personalSettings.showTitle}
        onCheckedChange={(val) => setPersonalSettings({ ...personalSettings, showTitle: val })}
        value={personalSettings.titleText}
        onValueChange={(val) => setPersonalSettings({ ...personalSettings, titleText: val })}
        showFontControls
        fontFamily={personalSettings.titleFontFamily}
        onFontFamilyChange={(val) => setPersonalSettings({ ...personalSettings, titleFontFamily: val })}
        fontSize={personalSettings.titleFontSize}
        onFontSizeChange={(val) => setPersonalSettings({ ...personalSettings, titleFontSize: val })}
        personalSettings={personalSettings}
        setPersonalSettings={setPersonalSettings}
      />

      <ToggleableInputGroup
        label="Add a Subtitle"
        placeholder="Enter subtitle..."
        checked={personalSettings.showSubtitle}
        onCheckedChange={(val) => setPersonalSettings({ ...personalSettings, showSubtitle: val })}
        value={personalSettings.subtitleText}
        onValueChange={(val) => setPersonalSettings({ ...personalSettings, subtitleText: val })}
        showFontControls
        fontFamily={personalSettings.subtitleFontFamily}
        onFontFamilyChange={(val) => setPersonalSettings({ ...personalSettings, subtitleFontFamily: val })}
        fontSize={personalSettings.subtitleFontSize}
        onFontSizeChange={(val) => setPersonalSettings({ ...personalSettings, subtitleFontSize: val })}
        personalSettings={personalSettings}
        setPersonalSettings={setPersonalSettings}
      />

      <ToggleableInputGroup
        label="Add a Legend"
        placeholder="Enter legend..."
        checked={personalSettings.showLegend}
        onCheckedChange={(val) => setPersonalSettings({ ...personalSettings, showLegend: val })}
        value={personalSettings.legendText}
        onValueChange={(val) => setPersonalSettings({ ...personalSettings, legendText: val })}
        personalSettings={personalSettings}
        setPersonalSettings={setPersonalSettings}
      />

    </div>
  );
}
